import { Injectable } from '@angular/core';
import { JsonApiResourceMapper, ResourceMapper, ResourceTypes } from '@big-direkt/json-api-client';
import { ParagraphTypes } from '@big-direkt/utils/shared';

import { NoticeAdvisoryBoxComponentModel } from './notice-advisory-box.model';
import { NoticeAdvisoryBoxResource } from './notice-advisory-box.resource';

@Injectable({
    providedIn: 'root',
})
@JsonApiResourceMapper
export class NoticeAdvisoryBoxMapper extends ResourceMapper<NoticeAdvisoryBoxComponentModel> {
    public static override readonly type: ResourceTypes = ResourceTypes.ParagraphBigNoticeAdvisoryBox;

    public map(resource: NoticeAdvisoryBoxResource): NoticeAdvisoryBoxComponentModel {
        return {
            type: ParagraphTypes.NoticeAdvisoryBox,
            id: resource.id ? `notice-advisory-box-${resource.id}` : undefined,
            link: resource.attributes.link
                ? {
                    title: resource.attributes.link.title,
                    url: resource.attributes.link.uri,
                }
                : undefined,
            text: resource.attributes.text?.value,
            title: resource.attributes.title,
            headingLevel: resource.attributes.heading_level,
            directoryTitle: resource.attributes.heading_level === 'h2' ? resource.attributes.title : undefined,
            svgIcon: resource.relationships.big_icon.data?.meta?.uri ?? '',
        };
    }
}
